import React, {useEffect, useState} from 'react';
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import axios from "axios";
import {API_PATH, WS_PATH} from "../../components/const";
import {toast} from "react-toastify";
import {Button, Modal, Select} from "antd";
import ReactPlayer from "react-player";

import ShakaPlayer from 'shaka-player-react';
import 'shaka-player/dist/controls.css';
import VideoCanvas from "./VideoCanvas";

const Live = () => {
    const [users, setUsers] = useState([])
    const [offices, setOffices] = useState([])
    const [parents, setParents] = useState([])
    const [rooms, setRooms] = useState([])
    const [cameras, setCameras] = useState([])
    const [selectOffices, setSelectOffices] = useState(null)
    const [selectRooms, setSelectRooms] = useState(null)
    const [selectCameras, setSelectCameras] = useState("")
    const [sendData, setSendData] = useState(null)
    const [message, setMessage] = useState({});
    const [time, setTime] = useState(new Date());
    const [playerReady, setPlayerReady] = useState(false);
    const [streamUrl, setStreamUrl] = useState(false);

    const handlePlayerReady = () => {
        setPlayerReady(true); // Плеер готов
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectImg, setSelectImg] = useState("");
    const showModal = (e) => {
        setSelectImg(e)
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const getUsers = () => {
        axios.get(API_PATH + "user/company/" + localStorage.getItem('id') + "/user/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setUsers(res.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getBuilding = (val,e) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res?.data)
                setSendData({...sendData, buildings_id: res.data.id})
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getParentBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/sections/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setParents(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getRooms = (id) => {
        getCameras(id)
        setSelectOffices(id)
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/room/" + id + "/all", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setRooms(res.data?.items)
                setSendData({...sendData, room_id: res.data.id})
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getRoomsSearch = (val) => {
        getCameras(selectOffices)
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/room/" + selectOffices + "/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setRooms(res.data?.items)
                setSendData({...sendData, room_id: res.data.id})
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getCameras = (id) => {
        setSelectRooms(id)
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/smartcamera/all?building_id=" + id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setCameras(res?.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
        window.scrollTo(0, 0);
    }
    const getCamerasSearch = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/smartcamera/all?building_id=" + selectRooms + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setCameras(res?.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
        window.scrollTo(0, 0);
    }
    const getAll = (id) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/camera/smartcamera/detail/" + id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setSelectCameras(res.data?.ddns_stream_url)
                setTimeout(() => {
                    setStreamUrl(true)
                }, 1000)
            })
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/visitor/" + id + "/captures", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setUsers(res.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
        const socket = new WebSocket(WS_PATH + "ws/" + id);
        socket.onmessage = (event) => {

            // setMessage(JSON.parse(event?.data?.replace(/'/g, '"')));
            // WebSocketdan kelgan datani userlarga qoshish joyi
            // setUsers(prevUsers => [JSON.parse(event?.data?.replace(/'/g, '"')), ...prevUsers]);

            axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/visitor/" + id + "/captures", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then(res => {
                    setUsers(res.data)
                })
                .catch(() => {
                    toast.error("Ошибка")
                })

        };
        return () => {
            socket.close();
        };
    }
    useEffect(() => {
        localStorage.setItem("sec", "")
        getBuilding()
        getParentBuilding()

    }, []);

    useEffect(() => {

    }, [message])

    return (
        <div className="live-page">
            <div className="employees-header">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="left-head">
                        <h6>Smart Camera </h6>
                        <p>Список камер</p>
                    </div>
                    <div className="right-head d-flex">
                        <div className="inputs-box mr-16" style={{width: "200px"}}>
                            <Select
                                showSearch
                                placeholder="Выберите раздел"
                                optionFilterProp="children"
                                className="w-100"
                                onSearch={getParentBuilding}
                                onChange={(e) => getBuilding(e)}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={parents?.map((item) => {
                                    return {
                                        value: item.id,
                                        label:
                                        item?.branch_title
                                    };
                                })}
                            />
                        </div>
                        <div className="inputs-box mr-16" style={{width: "200px"}}>
                            <Select
                                showSearch
                                placeholder="Выберите филиал"
                                optionFilterProp="children"
                                className="w-100"
                                // onSearch={getBuilding}
                                onChange={(e) => getRooms(e)}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={offices?.map((item) => {
                                    return {
                                        value: item.building_id,
                                        label:
                                        item?.branch_title
                                    };
                                })}
                            />
                        </div>
                        {/*<div className="inputs-box mr-16" style={{width: "200px"}}>*/}
                        {/*    <Select*/}
                        {/*        showSearch*/}
                        {/*        placeholder="Поиск, чтобы выбрать"*/}
                        {/*        optionFilterProp="children"*/}
                        {/*        className="w-100"*/}
                        {/*        onSearch={getRoomsSearch}*/}
                        {/*        onChange={(e) => getCameras(e)}*/}
                        {/*        // onChange={(e) => setCountry(e)}*/}
                        {/*        filterOption={(input, option) => (option?.label ?? '').includes(input)}*/}
                        {/*        filterSort={(optionA, optionB) =>*/}
                        {/*            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())*/}
                        {/*        }*/}
                        {/*        options={rooms?.map((item) => {*/}
                        {/*            return {*/}
                        {/*                value: item.id,*/}
                        {/*                label:*/}
                        {/*                item?.name*/}
                        {/*            };*/}
                        {/*        })}*/}
                        {/*    />*/}
                        {/*</div>*/}
                        <div className="inputs-box" style={{width: "200px"}}>
                            <Select
                                showSearch
                                placeholder="Выберите камера"
                                optionFilterProp="children"
                                className="w-100"
                                onSearch={getCamerasSearch}
                                onChange={(e) => getAll(e)}
                                // onChange={(e) => setCountry(e)}
                                filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                options={cameras?.map((item) => {
                                    return {
                                        value: item.id,
                                        label:
                                        item?.name
                                    };
                                })}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="live-page-box">
                <div className="live-page-box-header">
                    <div className="d-flex justify-content-between  ">
                        <div className="left-pair w-100">
                            {/*{*/}
                            {/*    selectCameras ? <ReactPlayer*/}
                            {/*                                 url={selectCameras}*/}
                            {/*                                 className="w-100 h-100 " style={{borderRadius: "8px"}}*/}
                            {/*                                 playing={true} muted/>*/}
                            {/*        :*/}
                            {/*        ""*/}
                            {/*}*/}
                            {
                                selectCameras ?
                                    <VideoCanvas src={selectCameras}/>
                                :
                                    ""
                            }

                        </div>
                        {
                            users?.length > 0 ?
                                <div className="right-pair-new-style">
                                    <span className="Screenshots">Скриншот</span>
                                    {
                                        users?.slice(0, 4)?.map((item) => (
                                            <div className="img-box">
                                                <div className="d-flex align-items-center w-100">
                                                    <div className="img-box-items">
                                                        <img
                                                            onClick={() => showModal(item?.image)}
                                                            src={(item?.image?.slice(0, 8) === "https://" || item?.image?.slice(0, 7) === "http://") ? item?.image : ("https://" + item?.image)}
                                                            className="img-box-item" alt=""/>
                                                    </div>
                                                    <div className="d-flex justify-content-between w-100 align-items-center">
                                                        <div className="img-box-items mr-16">
                                                        <span
                                                            style={{whiteSpace: "nowrap"}}>{item?.count_type === "visitor" ? "Посетитель" : item?.count_type === "employee" ? "Сотрудник" : item?.count_type === "revisitor" ? "Посетил снова" : "Посетил снова"}</span>
                                                        </div>
                                                        {
                                                            item?.gender === "male" || item?.gender === "female" ?
                                                                <div className="img-box-items img-box-items-active">
                                                                    <span>{item?.gender === "male" ? "Мужской" : item?.gender === "female" ? "Женский" : ""}</span>
                                                                </div>
                                                                :
                                                                ""
                                                        }

                                                    </div>
                                                </div>
                                                <div className="img-box-items">
                                                    <img src="/icon/timeclock.svg" alt="clock"/>
                                                    <span className="ml-8">{item?.created_at?.slice(11, 16)}</span>
                                                </div>

                                            </div>

                                        ))
                                    }
                                </div>
                                :
                                ""
                        }
                    </div>
                </div>
                {
                    (sendData?.buildings_id !== "" && users.length > 0)
                        ?
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 650}} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="pl20 table-head"
                                                   style={{width: "140px"}}>Скриншот</TableCell>
                                        <TableCell className="table-head" align="left">Имя</TableCell>
                                        {/*<TableCell className="table-head" align="left">Time</TableCell>*/}
                                        <TableCell className="table-head" align="left">Возраст</TableCell>
                                        <TableCell className="table-head" align="left">Пол</TableCell>
                                        <TableCell className="table-head" align="left">Засчитывается</TableCell>
                                        <TableCell className="pr20 table-head" align="left">Тип</TableCell>
                                        <TableCell className="table-head" align="right">Создан в</TableCell>

                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        users?.slice(0, 20)?.map((item, index) => (
                                            <TableRow
                                                key={index}
                                                sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                            >
                                                <TableCell className="pl20" style={{width: "140px"}} component="th"
                                                           scope="row">
                                                    <img
                                                        onClick={() => showModal(item?.image)}
                                                        src={(item?.image?.slice(0, 8) === "https://" || item?.image?.slice(0, 7) === "http://") ? item?.image : ("https://" + item?.image)}
                                                        alt="img" className="mr-8"
                                                        style={{width: "40px", borderRadius: "4px"}}/>


                                                </TableCell>

                                                <TableCell className="pr20 con-btns-all"
                                                           align="left">
                                                    {/*<span>{item?.first_name ? item?.first_name : ""}</span>*/}
                                                    {/*<span*/}
                                                    {/*    style={{marginLeft: "5px"}}>{item?.last_name ? item?.last_name : ""}</span>*/}
                                                    <span>
                                                        {(item?.first_name?.length > 0 || item?.last_name?.length > 0) ? item?.first_name + " " + item?.last_name : "Посетитель"}
                                                   </span>
                                                </TableCell>
                                                {/*<TableCell className="pr20 con-btns-all"*/}
                                                {/*           align="left">{item?.id}</TableCell>*/}

                                                <TableCell className="pr20 con-btns-all"
                                                           align="left">{item?.capture_type === "visitor" ? item?.age_interval : ""}</TableCell>
                                                <TableCell className="pr20 con-btns-all"
                                                           align="left">{item?.gender === "male" ? "Мужской" : item?.gender === "female" ? "Женский" : ""}</TableCell>
                                                {/*<TableCell className="pr20 con-btns-all"*/}
                                                {/*           align="left">{item?.created_at ? (item?.created_at?.slice(0, 10) + " / " + item?.created_at?.slice(11, 16)) : (time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" +  Number(time?.getDate())  + " / " ) }</TableCell>*/}

                                                <TableCell className="pr20 con-btns-all"
                                                           align="left">{item?.count_type === "visitor" ?
                                                    <img src="/icon/isc2.svg" alt="-"/> :
                                                    <img src="/icon/isc1.svg" alt="+"/>}
                                                </TableCell>
                                                <TableCell className="pr20 con-btns-all"
                                                           align="left">{item?.count_type === "visitor" ? "Посетитель" : item?.count_type === "employee" ? "Сотрудник" : item?.count_type === "revisitor" ? "Посетил снова" : "Посетил снова"}</TableCell>
                                                <TableCell className="pr20 con-btns-all"
                                                           align="right">{item?.created_at?.slice(0, 10) + " / " + item?.created_at?.slice(11, 16)}</TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        :
                        ""
                }

            </div>
            <Modal title="Скриншот"
                   open={isModalOpen}
                   onCancel={handleCancel}
                   footer={[
                       <Button key="submit" type="default" onClick={handleCancel}>
                           Отменить
                       </Button>,
                   ]}
            >
                <img
                    src={(selectImg?.slice(0, 8) === "https://" || selectImg?.slice(0, 7) === "http://") ? selectImg : ("https://" + selectImg)}
                    className="w-100" alt=""/>
            </Modal>
        </div>
    );
};
export default Live;